import React from "react";

const TableOfContents = ({ items = [], activeId, onSelect }) => {
  if (items.length === 0) return null;

  return (
    <aside className="hidden lg:block w-72 flex-shrink-0 sticky top-36 self-start max-h-[calc(100vh-160px)] overflow-y-auto custom-scrollbar">
      <div className="bg-white rounded-xl shadow-lg p-6 border border-grey/10">
        <h3 className="text-lg font-unbounded font-bold text-black mb-4">
          Table of Contents
        </h3>
        <nav>
          <ul className="space-y-2">
            {items.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => onSelect(item.id)}
                  className={`toc-link w-full text-left block text-sm font-poppins py-2 px-3 rounded-lg transition-all cursor-pointer ${
                    activeId === item.id
                      ? "active bg-primary text-white font-semibold shadow-md"
                      : "text-grey hover:bg-primary/5 hover:text-primary"
                  }`}
                >
                  {item.text}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default TableOfContents;